import { useCallback } from "react";
import { useRecordCameraActivity } from "@visioni/a3s-activity/app";
import type { ClipCompilationAccessMethod } from "@visioni/a3s-activity/client-messages";
import type { CompilationListItem } from "@visioni/a3s-media/app";
import { AssetCameraKey, SiteId } from "@visioni/a3s-schema";

/**
 * Records a `clip_compilation_viewed` audit entry for a compilation, saying
 * whether it was watched or downloaded.
 */
export function useRecordCompilationViewed(): (item: CompilationListItem, via: ClipCompilationAccessMethod) => void {
  const recordActivity = useRecordCameraActivity();

  return useCallback(
    (item: CompilationListItem, via: ClipCompilationAccessMethod) => {
      recordActivity({
        siteId: SiteId.fromString(item.siteId),
        assetCameraKey: AssetCameraKey.fromString(item.cameraKey),
        body: { kind: "clip_compilation_viewed", requestId: item.id, via },
      });
    },
    [recordActivity],
  );
}
